"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AnimalBirthdateDatepicker = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.parse-int.js");
var _react = _interopRequireWildcard(require("react"));
var _reactHookForm = require("react-hook-form");
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
var _dateFns = require("date-fns");
var _dateHelpers = require("../../../../../helpers/dateHelpers");
var _datepickerHelpers = require("../../../../../helpers/datepickerHelpers");
var _formFieldPropTypes = require("../../../../../propTypes/formFieldPropTypes");
var _ClickOutside = require("../../../../../hooks/ClickOutside");
var _EdgeProximityDetect = require("../../../../../hooks/EdgeProximityDetect");
var _InputText = require("../../InputText");
var _ValidationMessages = require("../../ValidationMessages");
var _Tooltip = require("../../../../UIElements/Tooltip/Tooltip");
var _Icon = require("../../../../UIElements/Icons/PetSure/Icon");
require("./Datepicker.scss");
require("./birthDate.scss");
var _ageHelpers = require("../../../../../helpers/ageHelpers");
const _excluded = ["fieldFormContext", "name", "label", "labelTooltip", "defaultValue", "minAgeInDays", "maxAgeInDays"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const AnimalBirthdateDatepicker = _ref => {
  var _rest$customCssClass;
  let {
      fieldFormContext,
      name,
      label,
      labelTooltip,
      defaultValue,
      minAgeInDays = 56,
      // 8 weeks in days
      maxAgeInDays = 7300 // 20 years in days
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const hookFormContext = (0, _reactHookForm.useFormContext)();
  const formContext = fieldFormContext || hookFormContext;
  const {
    clearErrors,
    setValue
  } = formContext;
  const currentDate = new Date();
  const minAgeTimeStamp = (0, _datepickerHelpers.MinAgeTimeStamp)(minAgeInDays);
  const maxAgeTimeStamp = (0, _datepickerHelpers.MaxAgeTimeStamp)(maxAgeInDays);
  const yearFieldMinMaxValue = {
    min: (0, _dateFns.getYear)(currentDate) - ((0, _dateFns.getYear)(currentDate) - (0, _dateFns.getYear)(new Date(maxAgeTimeStamp))),
    max: (0, _dateFns.getYear)(currentDate)
  };
  const datepickerElement = (0, _react.useRef)(null);
  const triggerElement = (0, _react.useRef)(null);
  const contentElement = (0, _react.useRef)(null);
  const [inputs, setInputs] = (0, _react.useState)({
    ["".concat(name, "_day")]: defaultValue ? String(new Date(defaultValue).getDate()).padStart(2, '0') : '',
    ["".concat(name, "_month")]: defaultValue ? String(new Date(defaultValue).getMonth() + 1).padStart(2, '0') : '',
    ["".concat(name, "_year")]: defaultValue ? new Date(defaultValue).getFullYear().toString() : ''
  });
  const [selectedDate, setSelectedDate] = (0, _react.useState)(null);
  const [showDatePicker, setShowDatePicker] = (0, _react.useState)(false);
  const toggleDatePicker = () => {
    setShowDatePicker(!showDatePicker);
  };
  (0, _ClickOutside.useOnClickOutside)(datepickerElement, () => setShowDatePicker(false));
  (0, _EdgeProximityDetect.useOnEdgeProximityDetect)({
    triggerRef: triggerElement,
    wrapperRef: datepickerElement,
    contentRef: contentElement,
    requiresRecalc: showDatePicker
  });
  const handleInputChange = (fieldName, value) => {
    const inputValue = value.replace(/[^0-9]/g, '');
    setInputs(prevInputs => _objectSpread(_objectSpread({}, prevInputs), {}, {
      [fieldName]: inputValue
    }));
    clearErrors(name);
  };
  const synchronizeDatePicker = () => {
    const {
      ["".concat(name, "_day")]: day,
      ["".concat(name, "_month")]: month,
      ["".concat(name, "_year")]: year
    } = inputs;
    if (day && month && year.length === 4) {
      const newDate = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
      setSelectedDate(newDate);
      validateDate(newDate);
      setValue(name, newDate);
    }
  };
  const isValidBirthdate = date => {
    return (0, _ageHelpers.isValidBirthdateRange)(date, minAgeTimeStamp, maxAgeTimeStamp, minAgeInDays, clearErrors, name);
  };
  const validateDate = date => {
    const validationMessage = isValidBirthdate(date);
    if (validationMessage) {
      formContext.setError(name, {
        type: 'manual',
        message: validationMessage
      });
      return false;
    }
    clearErrors(name);
    return true;
  };
  const customValidation = _objectSpread(_objectSpread({}, rest.validation), {}, {
    validate: _objectSpread(_objectSpread({}, rest.validation && rest.validation.validate), {}, {
      min: isValidBirthdate,
      max: isValidBirthdate
    })
  });
  const isValidInput = (inputValue, fieldName) => {
    return (0, _datepickerHelpers.ValidateInputField)(inputValue, fieldName, yearFieldMinMaxValue.min, yearFieldMinMaxValue.max);
  };
  const isValidDayInput = () => isValidInput(inputs["".concat(name, "_day")], 'Day');
  const isValidMonthInput = () => isValidInput(inputs["".concat(name, "_month")], 'Month');
  const isValidYearInput = () => isValidInput(inputs["".concat(name, "_year")], 'Year');
  const customDayValidation = {
    validate: {
      required: isValidDayInput
    }
  };
  const customMonthValidation = {
    validate: {
      required: isValidMonthInput
    }
  };
  const customYearValidation = {
    validate: {
      required: isValidYearInput
    }
  };
  const minDate = (0, _dateHelpers.DateToShortIsoString)(new Date(maxAgeTimeStamp));
  const maxDate = (0, _dateHelpers.DateToShortIsoString)(new Date(minAgeTimeStamp));
  const handleDatePickerChange = date => {
    setSelectedDate(date);
    if (date) {
      clearErrors(name);
      clearErrors("".concat(name, "_day"));
      clearErrors("".concat(name, "_month"));
      clearErrors("".concat(name, "_year"));
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear().toString();
      setInputs({
        ["".concat(name, "_day")]: day,
        ["".concat(name, "_month")]: month,
        ["".concat(name, "_year")]: year
      });
      validateDate(date);
      setValue(name, date);
    }
    toggleDatePicker();
  };
  const years = (0, _datepickerHelpers.YearRange)((0, _dateFns.getYear)(new Date(maxAgeTimeStamp)), (0, _dateFns.getYear)(currentDate), 1);
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  return /*#__PURE__*/_react.default.createElement("fieldset", {
    className: "birthDateContainer ".concat((_rest$customCssClass = rest === null || rest === void 0 ? void 0 : rest.customCssClass) !== null && _rest$customCssClass !== void 0 ? _rest$customCssClass : '')
  }, label && /*#__PURE__*/_react.default.createElement("p", {
    className: "".concat(rest.required ? 'mandatory' : '')
  }, label, labelTooltip && /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    customTrackingData: {
      tooltipForLabel: {
        label
      }
    }
  }, labelTooltip)), /*#__PURE__*/_react.default.createElement("div", {
    className: "birthDateInputContainer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: datepickerElement
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    "aria-label": "Toggle datepicker",
    className: "button icon_only",
    ref: triggerElement,
    onClick: () => {
      toggleDatePicker();
    }
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "calendar"
  })), /*#__PURE__*/_react.default.createElement("div", {
    ref: contentElement,
    className: "datepicker-wrapper"
  }, showDatePicker && /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, {
    selected: selectedDate,
    onChange: date => {
      handleDatePickerChange(date);
    },
    inline: true,
    minDate: minDate,
    maxDate: maxDate,
    renderCustomHeader: _ref2 => {
      let {
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled
      } = _ref2;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "custom-header"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        "aria-label": "Previous month",
        className: "arrow-button",
        onClick: decreaseMonth,
        disabled: prevMonthButtonDisabled
      }, '<'), /*#__PURE__*/_react.default.createElement("select", {
        "aria-label": "Select month",
        className: "month-select",
        value: months[(0, _dateFns.getMonth)(date)],
        onChange: _ref3 => {
          let {
            target: {
              value
            }
          } = _ref3;
          return changeMonth(months.indexOf(value));
        }
      }, months.map(option => /*#__PURE__*/_react.default.createElement("option", {
        key: option,
        value: option
      }, option))), /*#__PURE__*/_react.default.createElement("select", {
        "aria-label": "Select year",
        className: "year-select",
        value: (0, _dateFns.getYear)(date),
        onChange: _ref4 => {
          let {
            target: {
              value
            }
          } = _ref4;
          return changeYear(value);
        }
      }, years.map(option => /*#__PURE__*/_react.default.createElement("option", {
        key: option,
        value: option
      }, option))), /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        "aria-label": "Next month",
        className: "arrow-button",
        onClick: increaseMonth,
        disabled: nextMonthButtonDisabled
      }, '>'));
    }
  }))), /*#__PURE__*/_react.default.createElement(_InputText.InputText, {
    inputType: "date",
    name: name,
    value: selectedDate ? (0, _dateHelpers.DateToShortIsoString)(new Date(selectedDate)) : defaultValue,
    fieldFormContext: formContext,
    validation: customValidation,
    customCssClass: "custom-datepicker-field"
  }), /*#__PURE__*/_react.default.createElement(_InputText.InputText, {
    inputType: "number",
    placeholder: "DD",
    name: "".concat(name, "_day"),
    value: inputs["".concat(name, "_day")],
    labelIsInset: true,
    customChangeHandler: event => handleInputChange("".concat(name, "_day"), event.target.value),
    onBlur: synchronizeDatePicker,
    min: "0",
    max: "31",
    fieldFormContext: formContext,
    validation: customDayValidation
  }), /*#__PURE__*/_react.default.createElement(_InputText.InputText, {
    inputType: "number",
    placeholder: "MM",
    name: "".concat(name, "_month"),
    value: inputs["".concat(name, "_month")],
    labelIsInset: true,
    customChangeHandler: event => handleInputChange("".concat(name, "_month"), event.target.value),
    onBlur: synchronizeDatePicker,
    min: "0",
    max: "12",
    fieldFormContext: formContext,
    validation: customMonthValidation
  }), /*#__PURE__*/_react.default.createElement(_InputText.InputText, {
    inputType: "number",
    placeholder: "YYYY",
    name: "".concat(name, "_year"),
    value: inputs["".concat(name, "_year")],
    labelIsInset: true,
    customChangeHandler: event => handleInputChange("".concat(name, "_year"), event.target.value),
    onBlur: synchronizeDatePicker,
    min: yearFieldMinMaxValue.min,
    max: yearFieldMinMaxValue.max,
    fieldFormContext: formContext,
    validation: customYearValidation
  })), /*#__PURE__*/_react.default.createElement(_ValidationMessages.ValidationMessages, {
    formContext: formContext,
    name: name,
    validation: customValidation
  }));
};
exports.AnimalBirthdateDatepicker = AnimalBirthdateDatepicker;
AnimalBirthdateDatepicker.propTypes = _formFieldPropTypes.FormFieldPropTypes;
var _default = exports.default = AnimalBirthdateDatepicker;